import { Icon } from '@iconify/react';
import googleFill from '@iconify/icons-eva/google-fill';
import twitterFill from '@iconify/icons-eva/twitter-fill';
import facebookFill from '@iconify/icons-eva/facebook-fill';
import linkedinFill from '@iconify/icons-eva/linkedin-fill';
import { Link as ScrollLink } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';
// material
import { experimentalStyled as styled } from '@material-ui/core/styles';
import { Grid, Link, Divider, Container, Typography, IconButton, Stack, Box } from '@material-ui/core';
// routes
import { PATH_PAGE } from '../../routes/paths';
//
import Logo from '../../components/Logo';
import { LocationOnOutlined, MailOutline, MailOutlined, PhoneOutlined } from '@material-ui/icons';

// ----------------------------------------------------------------------

const SOCIALS = [
  { name: 'FaceBook', icon: facebookFill },
  { name: 'Google', icon: googleFill },
  { name: 'Linkedin', icon: linkedinFill },
  { name: 'Twitter', icon: twitterFill }
];

// const LINKS = [
//   {
//     headline: 'e-Gov',
//     children: [
//       { name: 'About us', href: PATH_PAGE.about },
//       { name: 'Contact us', href: PATH_PAGE.contact },
//       { name: 'FAQs', href: PATH_PAGE.faqs }
//     ]
//   },
//   {
//     headline: 'Legal',
//     children: [
//       { name: 'Terms and Condition', href: '#' },
//       { name: 'Privacy Policy', href: '#' }
//     ]
//   },
//   {
//     headline: 'Contact',
//     children: [
//       { name: 'support@minimals.cc', href: '#' },
//       { name: 'Los Angeles, 359  Hidden Valley Road', href: '#' }
//     ]
//   }
// ];

const LINKS = [
  {
    headline: 'Quick Links',
    children: [
      { name: 'The People', href: "#" },
      { name: 'The Government', href: "#" },
      { name: 'Visit Plateau', href: "#" }
    ]
  },
  {
    headline: 'Services',
    children: [
      { name: 'Tax Services', href: '#' },
      { name: 'Business Registration', href: '#' },
      { name: 'Online Applications', href: '#' }
    ]
  },
  {
    headline: 'Contact Us',
    children: [
      { name: 'Government House, Jos, Plateau State', href: '#', icon: LocationOnOutlined },
      { name: '+234 803 123 4567', href: '#', icon: PhoneOutlined },
      { name: 'info@plateaustate.gov.ng', href: '#', icon: MailOutlined }
      
    ]
  }
];
const RootStyle = styled('div')(({ theme }) => ({
  position: 'relative',
  backgroundColor: theme.palette.background.default
}));

// ----------------------------------------------------------------------

export default function MainFooter() {
  return (
    <RootStyle>
      {/* <Divider /> */}

      <Container
        maxWidth="false"
        sx={{ pb: 4,pt:4, bgcolor: 'primary.main', color: 'white' }}
      >
        <Grid
          container
          justifyContent={{ xs: 'center', md: 'space-between' }}
          sx={{ textAlign: { xs: 'center', md: 'left' } ,px: 4,}}
        >
          {/* <Grid item xs={12} sx={{ mb: 3 }}>
            <ScrollLink to="move_top" spy smooth>
              <Logo sx={{ mx: { xs: 'auto', md: 'inherit' } }} />
            </ScrollLink>
          </Grid> */}
          <Grid
            item
            xs={8}
            md={4}
            sx={{
              textAlign: {md:'left',sm:'center'},
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: {md:'flex-start',sm:'center'},
            }}
          >
            <Typography variant="h5" sx={{ mb: 1 }}>
              Plateau State Government
            </Typography>
            <Typography variant="body2" sx={{ maxWidth: '300px' }}>
              Serving the people of Plateau State with transparency, efficiency,
              and digital innovation.
            </Typography>
            {/* <Stack
              spacing={1.5}
              direction="row"
              justifyContent={{ xs: 'center', md: 'flex-start' }}
              sx={{ mt: 5, mb: { xs: 5, md: 0 } }}
            >
              {SOCIALS.map((social) => (
                <IconButton key={social.name} color="primary" sx={{ p: 1 }}>
                  <Icon icon={social.icon} width={16} height={16} />
                </IconButton>
              ))}
            </Stack> */}
          </Grid>

          <Grid item xs={12} md={8}>
            {/* <Stack spacing={5} direction={{ xs: 'column', md: 'row' }} justifyContent="space-between">
              {LINKS.map((list) => {
                const { headline, children } = list;
                return (
                  <Stack key={headline} spacing={2}>
                    <Typography component="p" variant="overline">
                      {headline}
                    </Typography>
                    {children.map((link) => (
                      
                      <Link
                        to={link.href}
                        key={link.name}
                        color="inherit"
                        variant="body2"
                        component={RouterLink}
                        sx={{ display: 'block' }}
                      >
                        {link.name}
                      </Link>
                    ))}
                  </Stack>
                );
              })}
            </Stack> */}
            <Stack
              sx={{ mt: { xs: 3, md: 0 } }}
              spacing={3}
              direction={{ xs: 'column', md: 'row' }}
              justifyContent={{ md: 'space-between', xs: 'center' }}
            >
              {LINKS.map(({ headline, children }) => (
                <Stack key={headline}>
                  <Typography variant="h5" sx={{ mb: 1 }}>
                    {headline}
                  </Typography>

                  {children.map(({ name, href, icon: Icon }) => (
                    <Stack
                      key={name}
                      direction={{ xs: 'column', md: 'row' }}
                      alignItems="center"
                    >
                      {Icon ? (
                        <Icon
                          fontSize="small"
                          sx={{
                            color: '#9acd32',
                            mr: 1,
                            height: '15px',
                            width: '15px',
                          }}
                        />
                      ) : null}
                      <Link
                        to={href}
                        color="inherit"
                        variant="body2"
                        component={RouterLink}
                        sx={{ display: 'block' }}
                      >
                        {name}
                      </Link>
                    </Stack>
                  ))}
                </Stack>
              ))}
            </Stack>
          </Grid>
          <Divider sx={{ width: '100%', mt: 5, bgcolor: '#9acd32' }} />
          {/* <Box
            sx={{ bgcolor: '#9acd32', width: '100%', height: 2, mt: 4 }}
          ></Box> */}
        </Grid>
        <Stack
          sx={{
            px: 4,
            py: 2,
            color: 'grey.500',
            display: 'flex',
            flexDirection: {
              md: 'row',
              xs: 'column',
              justifyContent: 'space-between',
              alignItems: 'center',
            },
          }}
        >
          <Typography
            component="p"
            variant="body2"
            sx={{
              mt: 2,
              fontSize: 15,
              textAlign: { xs: 'center', md: 'left' },
            }}
          >
            {/* © 2021. All rights reserved */}© 2025 Plateau State Government.
            All rights reserved.
          </Typography>
          <Stack
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: { md: 'flex-end',xs: 'start', },
              gap: 3,
              mt: 2,
              alignItems: 'center'
            }}
          >
            <Typography variant="body2">Privacy Policy</Typography>
            <Typography variant="body2">Terms of Services</Typography>
          </Stack>
        </Stack>
      </Container>
    </RootStyle>
  )
}
